import { OrganizationCode } from 'merchandising-sdk';

export const environment = {
  production: false,
  organization: OrganizationCode.SAS,
  is_online: true,
  assets_url: 'https://stmerchandisingsas.blob.core.windows.net/sas-assets',
  local_db_name: 'merchandising.db',
  azure_blob_sas_url: `https://stmerchandisingsas.blob.core.windows.net/?sv=2021-10-04&ss=btqf&srt=sco&st=2025-02-19T14%3A30%3A00Z&se=2030-12-31T14%3A30%3A00Z&sp=rwdxlacup&sig=j11RyDsG6d2E6X1Go0s0o6OivQ5QOLFgIimNG5vxBAQ%3D`,
  azure_container: `sas-assets`,
  azure_container_uploads: `uploads`
};